import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  baseUrl: string = environment.baseUrl;
  constructor(private http: HttpClient) { }

  requestMultiLicenses(files: File[], email: string, company:string, contact:string, contactPersionPhone:string, country:string, applicationType:string) {
    const formData = new FormData();

    for (const file of files) {
      formData.append('csvFile', file, file.name);
    }

    formData.append('email', email);
    formData.append('company', company);
    formData.append('contact', contact);
    formData.append('contactPersionPhone', contactPersionPhone);
    formData.append('country', country);
    formData.append('applicationType', applicationType);

    return this.http
      .post(`${this.baseUrl}/Generate/Batch`, formData)
      .pipe(catchError(error => this.handleError(error)));
  }

  requestVOMLicenses(files: File[], email: string, company:string, contact:string, contactPersionPhone:string, country:string
    , applicationType:string, vmsType:string, code:string, licenseType:string, modelName:string, macAddress:string
  , description:string) {
    const formData = new FormData();

    for (const file of files) {
      formData.append('csvFile', file, file.name);
    }

    formData.append('email', email);
    formData.append('company', company);
    formData.append('contact', contact);
    formData.append('contactPersionPhone', contactPersionPhone);
    formData.append('country', country);
    formData.append('applicationType', applicationType);
    formData.append('vmsType', vmsType);
    formData.append('code', code);
    formData.append('licenseType', licenseType);
    formData.append('modelName', modelName);
    formData.append('macAddress', macAddress);
    formData.append('description', description);

    return this.http
      .post(`${this.baseUrl}/Generate/VOMSendDownloadLink`, formData)
      .pipe(catchError(error => this.handleError(error)));
  }

  requestSingleLicense(conditions: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/Generate/Single`, conditions)
      .pipe(catchError(error => this.handleError(error)));
  }

  generateVOMLicense(key: any): Observable<any> {
    return this.http
    .get(`${this.baseUrl}/Generate/LicenseVOM?id=` + encodeURIComponent(key).replace(/%20/g, '+'))
    .pipe(catchError(error => this.handleError(error)));
  }

  requestSingleAndSendMailLicense(conditions: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/Generate/SingleAndSendMail`, conditions)
      .pipe(catchError(error => this.handleError(error)));
  }

  getCodeTypes(): Observable<any> {
    return this.http.get(`${this.baseUrl}/Code/All`).pipe(
      map((data: any) => data.resultObj),
      catchError(error => this.handleError(error))
    );
  }

  getCaptcha(): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/Generate/Captcha`)
      .pipe(catchError(error => this.handleError(error)));
  }

  verifyCaptcha(model: { image: string; key: string }) {
    return this.http
      .post(`${this.baseUrl}/Generate/Captcha`, model)
      .pipe(catchError(error => this.handleError(error)));
  }

  private handleError(error: any) {
    console.log(`api-error`, error);
    return throwError(error);
  }
}
